import type { GroupMembershipMeta } from '@/types/group';

/**
 * Whether to show the admin "pending join requests" red dot on a circle's gear (#2).
 * Admin-only and only when there is at least one pending request. Backend already
 * returns 0 for non-admins, but we re-check role here as defence in depth (UX gate).
 */
export function shouldShowPendingDot(membership: GroupMembershipMeta | null | undefined): boolean {
  if (!membership) return false;
  return membership.role === 'admin' && (membership.pendingCount ?? 0) > 0;
}

/**
 * A9 — badge label for a circle chip's unseen new sounds. Returns the count
 * ("9+" past nine) or null when there is nothing new to surface.
 */
export function unseenBadgeLabel(
  membership: GroupMembershipMeta | null | undefined,
): string | null {
  const count = membership?.unseenCount ?? 0;
  if (count <= 0) return null;
  return count > 9 ? '9+' : String(count);
}
